export default __webpack_public_path__ + "static/media/phonebg.7295df56.webp";